import React, { useState } from 'react';

import { useMediaQuery } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { useTheme } from 'styled-components';

import Button, { ButtonProps } from '../Button';
import DataGrid, { DataGridProps } from '../DataGrid';
import SearchField from '../SearchField';

import {
  ControlContainer,
  GrowContainer,
  PermissionsListContainer,
  PermissionsSearch,
} from './index.styles';

interface PermissionsListProps extends Omit<DataGridProps, 'rows' | 'columns'> {
  data: any[],
  columns: GridColDef[],
  loading?: boolean,
  onAddClick?: () => void,
  search?: boolean,
  addButtonProps?: ButtonProps,
  pageSize?: number,
}

const PermissionsList = ({ data,
  columns,
  loading,
  addButtonProps,
  onAddClick,
  pageSize,
  search = true,
  ...props }: PermissionsListProps) => {
  const theme = useTheme();
  const isMd = useMediaQuery(theme.breakpoints.up('md'));

  const [filterStr, setFilterStr] = useState('');

  return (
    <PermissionsListContainer>
      {search && (
        <ControlContainer>
          <PermissionsSearch>
            <SearchField
              collapseEnabled
              placeholder={isMd ? 'Filter Permission...' : 'Filter...'}
              onSearch={(searchStr) => setFilterStr(searchStr)}
            />
          </PermissionsSearch>
          {onAddClick && (
            <Button
              {...addButtonProps}
              size="medium"
              onClick={onAddClick}
            >
              {isMd ? '+ Add' : '+'}
            </Button>
          )}
        </ControlContainer>
      )}
      <GrowContainer>
        <DataGrid
          rows={data.filter((row) =>
            row.label?.toLowerCase().includes(filterStr.toLowerCase()),
          ).map((row) => ({
            ...row,
            id: row.value,
          }))}
          columns={columns}
          pageSizeOptions={pageSize ? [pageSize] : [10, 30]}
          getRowId={(row) => row.id}
          autoHeight
          loading={loading && !!data}
          {...props}
        />
      </GrowContainer>
    </PermissionsListContainer>
  );
};

export default PermissionsList;
